import React from 'react';
import { FadeIn } from './ui/FadeIn';
import { X } from 'lucide-react';
export function Mistakes() {
  const mistakes = [{
    title: '“Me quedo en cama hasta dormirme”',
    result: 'Tu cerebro aprende: cama = ring de pelea.'
  }, {
    title: '“Me pongo a ver el celular un ratito”',
    result: 'Tu cerebro aprende: esto es una emergencia.'
  }, {
    title: '“Tomo algo y ya”',
    result: 'Si el miedo queda vivo, el circuito se repite.'
  }];
  return <section className="py-20 px-6 bg-slate-950" data-id="element-157">
      <div className="max-w-3xl mx-auto" data-id="element-158">
        <FadeIn data-id="element-159">
          <h2 className="text-3xl font-bold text-white mb-12 text-center" data-id="element-160">
            Por qué lo que intentaste antes no te sostuvo
          </h2>
        </FadeIn>

        <div className="space-y-6" data-id="element-161">
          {mistakes.map((item, idx) => <FadeIn key={idx} delay={idx * 100} data-id="element-162">
              <div className="flex items-start gap-4 p-6 rounded-xl bg-slate-900 border border-slate-800" data-id="element-163">
                <div className="mt-1 bg-red-500/10 rounded-full p-1" data-id="element-164">
                  <X size={20} className="text-red-500" data-id="element-165" />
                </div>
                <div data-id="element-166">
                  <h3 className="text-lg font-semibold text-white mb-1" data-id="element-167">
                    {item.title}
                  </h3>
                  <p className="text-slate-400" data-id="element-168">→ {item.result}</p>
                </div>
              </div>
            </FadeIn>)}
        </div>

        <FadeIn delay={400} data-id="element-169">
          <div className="mt-12 text-center" data-id="element-170">
            <p className="text-xl text-slate-300" data-id="element-171">
              No es culpa tuya. <br data-id="element-172" />
              <span className="text-amber-400 font-medium" data-id="element-173">
                Es que nadie te dio instrucciones para el minuto a minuto.
              </span>
            </p>
          </div>
        </FadeIn>
      </div>
    </section>;
}